import { all } from 'redux-saga/effects'

import listSaga from './list/saga'
import { seeSaga } from './see/saga'

export function* receivedSaga() {
  yield all([listSaga(), seeSaga()])
}
